<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <div class="row">
                <div class="col-12 mb-1">
                    <label class="form-label">Ad <span class="text-danger">*</span></label>
                    <v-validator :errors="errors" parameter="Name" :watch="form.Name">
                        <input type="text" class="form-control" placeholder="Ad" v-model="form.Name" />
                    </v-validator>
                </div>

                <div class="col-12 mb-1">
                    <label class="form-label">Açıklama</label>
                    <v-validator :errors="errors" parameter="Description" :watch="form.Description">
                        <input class="form-control" rows="2" placeholder="Açıklama" v-model="form.Description" />
                    </v-validator>
                </div>
                <div class="col-12 mb-1">
                    <label class="form-label">Şube <span class="text-danger">*</span></label>
                    <v-validator :errors="errors" parameter="BranchId" :watch="form.BranchId">
                        <v-select-list v-model="branch" :options="branches" label="Name" placeholder="Şube Seçiniz" />
                    </v-validator>
                </div>
            </div>

            <template #modal-footer>
                <v-executer :loading="loading" :editing="editing" :action="createOrUpdate" :disabled="isSaveDisabled" />
            </template>
        </b-modal>

        <v-table ref="table" :add-callback="createNew" :fields="fields" name="fuel-storage-class" :buttons="buttons" pagination="client" search :items-provider="provider" />
    </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue";
import api from "@/api/fuel-storage";
import CompanyApi from "@/api/company";

export default {
    name: "FuelStorageClassView",
    components: { BCard },

    data() {
        return {
            errors: {},
            editing: false,
            loading: false,
            branches: [],
            form: {
                Id: null,
                Name: "",
                Description: "",
                BranchId: null,
            },
            fields: [
                {
                    name: "Ad",
                    key: "Name",
                    sortable: true,
                    thClass: "w-30 text-nowrap",
                    tdClass: "text-nowrap text-left",
                },
                {
                    name: "Açıklama",
                    key: "Description",
                    sortable: true,
                    thClass: "w-40 text-nowrap",
                    tdClass: "text-nowrap text-left",
                },
                {
                    name: "Şube",
                    key: "BranchName",
                    sortable: true,
                    thClass: "w-30 text-nowrap",
                    tdClass: "text-nowrap text-left",
                },
            ],
            buttons: [
                {
                    text: "Düzenle",
                    key: "edit",
                    icon: "Edit2Icon",
                    variant: "secondary",
                    action: this.edit,
                },
                {
                    text: "Sil",
                    key: "delete",
                    icon: "TrashIcon",
                    variant: "danger",
                    action: this.deleteRow,
                },
            ],
        };
    },
    mounted() {
        this.loadBranches();
    },
    computed: {
        branch: {
            get() {
                return this.branches.find((b) => b.Id === this.form.BranchId) || null;
            },
            set(val) {
                this.form.BranchId = val?.Id || null;
            },
        },
        isSaveDisabled() {
            return !this.form.Name || this.form.Name.trim() === "" || !this.form.BranchId;
        },
    },
    methods: {
        clearForm() {
            this.editing = false;
            this.form = { Id: null, Name: "", Description: "", BranchId: null };
        },

        async loadBranches() {
            try {
                const res = await CompanyApi.Branch.ListByCode("O");
                if (res.data.Success) this.branches = res.data.Data || [];
            } catch (err) {
                console.error("Error loading branches:", err);
            }
        },
        createNew() {
            this.clearForm();
            this.$showModal("create-or-update");
        },

        edit(item) {
            this.editing = true;
            this.form = {
                Id: item.Id,
                Name: item.Name,
                Description: item.Description,
                BranchId: item.BranchId,
            };
            this.$showModal("create-or-update");
        },

        provider() {
            return api.FuelStorageClass.List();
        },

        createOrUpdate() {
            this.loading = true;
            api.FuelStorageClass.CreateOrUpdate(this.editing, this.form)
                .then((res) => {
                    if (res.data.Success) {
                        this.$refs.table.refresh();
                        this.$hideModal("create-or-update");
                        this.clearForm();
                    }
                    this.$result(res);
                })
                .catch((err) => this.$result(null, err))
                .finally(() => (this.loading = false));
        },

        deleteRow(item) {
            this.$confirm("Silmek istediğinize emin misiniz?", `${item.Name} sınıfı silinecek ve geri alınamaz.`).then((ok) => {
                if (!ok) return;
                api.FuelStorageClass.Delete(item.Id)
                    .then((res) => {
                        if (res.data.Success) this.$refs.table.refresh();
                        this.$result(res);
                    })
                    .catch((err) => this.$result(null, err));
            });
        },
    },
};
</script>

<style scoped></style>
